import _ from 'lodash'

import { getenv } from '~/settings'

const win = typeof window !== 'undefined' ? window : {}
const useLogger = getenv('USE_LOGGER')

export default {
    exception(e, meta) {
        console.error(e) // eslint-disable-line no-console
        if (meta) {
            console.error('Error meta:', meta) // eslint-disable-line no-console
        }
        try {
            if (typeof win.Sentry !== 'undefined') {
                win.Sentry.withScope(scope => {
                    _.forEach(meta?.extra || {}, (value, key) => {
                        scope.setExtra(key, value)
                    })
                    _.forEach(meta?.tags || {}, (value, key) => {
                        scope.setTag(key, value)
                    })
                    win.Sentry.captureException(e)
                })
            }
        } catch (exc) {
            /* just fail silently */
        }
    },
    openErrorFeedback() {
        if (typeof win.Sentry !== 'undefined' && win.Sentry.lastEventId()) {
            win.Sentry.showReportDialog()
            return true
        }
        this.warn('No Sentry available. Could not open feedback dialog.')
        return false
    },
    /* eslint-disable-next-line no-console */
    debug: useLogger ? console.debug.bind(console) : _.noop,
    /* eslint-disable-next-line no-console */
    warn: useLogger ? console.warn.bind(console) : _.noop,
    /* eslint-disable-next-line no-console */
    info: useLogger ? console.info.bind(console) : _.noop,
    /* eslint-disable-next-line no-console */
    error: useLogger ? console.error.bind(console) : _.noop,
    /* eslint-disable-next-line no-console */
    log: useLogger ? console.log.bind(console) : _.noop,
}
